import ReactGA from "react-ga";
import { makeAutoObservable } from "mobx";
import {
  UserInterface,
  UserSubscriptionInterface,
} from "../types/interfaces/User.interface";
import { isPast } from "date-fns";
import { localStorageUtils } from "../utils/browser-utils/LocalStorage";
import { ProfileTabEnum } from "../types/enums/ProfileTab.enum";

export class UserStore {
  public user: UserInterface | null = null;
  public isSubscriptionActive: boolean = false;
  public isUserLoading = false;

  // TODO: move to separate modal store
  public isPlanModalOpen = false;
  public isSignInModalOpen = false;
  public isSignUpModalOpen = false;
  public isAddPostModalOpen = false;

  public isSignUpBonusOpen = false;

  public accountTab: ProfileTabEnum = ProfileTabEnum.TRADING;

  public isPostsVisited = false;
  public isTradingVisited = false;

  constructor() {
    makeAutoObservable(this);

    this.setCurrentUser = this.setCurrentUser.bind(this);
    this.setIsUserLoading = this.setIsUserLoading.bind(this);
    this.updateUserSubscription = this.updateUserSubscription.bind(this);

    // TODO: move to separate modal store
    this.setPlanModalOpenClose = this.setPlanModalOpenClose.bind(this);
    this.setPlanModalClose = this.setPlanModalClose.bind(this);
    this.setSignInModalOpenClose = this.setSignInModalOpenClose.bind(this);
    this.setSignUpModalOpenClose = this.setSignUpModalOpenClose.bind(this);
    this.setAddPostModalOpenClose = this.setAddPostModalOpenClose.bind(this);

    this.setProfileTab = this.setProfileTab.bind(this);

    this.logout = this.logout.bind(this);

    this.toggleSignUpBonusModal = this.toggleSignUpBonusModal.bind(this);

    this.setPostsVisited = this.setPostsVisited.bind(this);
    this.setTradingVisited = this.setTradingVisited.bind(this);
  }

  setCurrentUser(user: UserInterface) {
    this.user = user;
    const isActive = user?.subscription?.activeTill
      ? !isPast(new Date(user?.subscription?.activeTill))
      : false;
    this.isSubscriptionActive = isActive;

    if (!isActive && user?.id) {
      this.isPlanModalOpen = true;
    }
  }

  updateUserSubscription(subscription: UserSubscriptionInterface) {
    const updatedUser = {
      ...this.user,
      subscription,
    } as UserInterface;

    this.isSubscriptionActive =
      !isPast(new Date(subscription?.activeTill)) || false;

    this.user = updatedUser;
  }

  setIsUserLoading(isLoading: boolean) {
    this.isUserLoading = isLoading;
  }

  // TODO: move to separate modal store
  setPlanModalOpenClose() {
    this.isPlanModalOpen = !this.isPlanModalOpen;
  }
  setPlanModalClose() {
    this.isPlanModalOpen = false;
  }
  setSignInModalOpenClose() {
    this.isSignInModalOpen = !this.isSignInModalOpen;

    if (this.isSignUpModalOpen) {
      ReactGA.event({
        category: "auth",
        action: "Click",
        label: "open-sign-in-modal",
      });
    }
  }
  setSignInModalClose() {
    this.isSignInModalOpen = false;
  }
  setSignUpModalOpenClose() {
    this.isSignUpModalOpen = !this.isSignUpModalOpen;
  }
  setAddPostModalOpenClose() {
    this.isAddPostModalOpen = !this.isAddPostModalOpen;
  }

  setProfileTab(tab: ProfileTabEnum) {
    this.accountTab = tab;
  }

  logout() {
    this.user = null;
    this.isSubscriptionActive = false;

    localStorageUtils.clearAuthData();
  }

  toggleSignUpBonusModal() {
    this.isSignUpBonusOpen = !this.isSignUpBonusOpen;
  }

  setPostsVisited() {
    this.isPostsVisited = true;
  }

  setTradingVisited() {
    this.isTradingVisited = true;
  }
}
